<template>
	<div
			:class="[
					'itemInfo', customClass, {'bigValue': isBigValue},
					{'flexStart': isFlexStart},
					{'flexStart': isFlexStart},
					{'isClickIcon': isClickIcon},
					{'isClickValue': isClickValue}
					]"
			:style="{ margin }"
	>
		<div v-if="isItemIcon" class="icon"  @click="onClickIcon">
			<svg-sprite :color="iconColor" :icon-id="iconId" :width="iconWidth" :height="iconHeight"></svg-sprite>
		</div>
		<div v-if="isItemEmoji" class="icon"  @click="onClickIcon" v-html="emoji"></div>
		<div v-if="isItemSubText" class="subTextWrap">
			<div class="text">{{ subText }}</div>
		</div>
		<div v-if="isItemText" class="textWrap">
			<div class="text">{{ text }}</div>
		</div>
		<div v-if="isItemDashed" class="dashed"></div>
		<div v-if="isItemValue" class="valueWrap" @click="onClickValue">
			<svg-sprite v-if="isValueFirstIcon" :icon-id="valueFirstIcon" :color="valueFirstIconColor" :width="valueFirstIconWidth" :height="valueFirstIconHeight"></svg-sprite>
			<span class="value">{{ value }}</span>
			<svg-sprite v-if="isValueIcon" :icon-id="valueIcon" :color="valueIconColor" :width="valueIconWidth" :height="valueIconHeight"></svg-sprite>
		</div>
	</div>
</template>
<script>
export default {
	name: "ItemInfoRow",
	props: {
		isItemEmoji: Boolean,
		emoji: String,
		isItemSubText: Boolean,
		subText: String,
		isClickIcon: Boolean,
		isClickValue: Boolean,
		isBigValue: Boolean,
		isFlexStart: Boolean,
		customClass: String,
		text: String,
		value: [ String, Number ],
		iconId: String,
		iconColor: {
			type: String,
			default: '#19bc38'
		},
		isItemDashed: {
			type: Boolean,
			default: true
		},
		isItemIcon: {
			type: Boolean,
			default: true
		},
		isItemText: {
			type: Boolean,
			default: true
		},
		isItemValue: {
			type: Boolean,
			default: true
		},
		iconWidth: {
			type: String,
			default: '20px'
		},
		iconHeight: {
			type: String,
			default: '20px'
		},
		isValueIcon: Boolean,
		valueIcon: String,
		valueIconColor: {
			type: String,
			default: '#a3a3a3'
		},
		valueIconWidth: {
			type: String,
			default: '20px'
		},
		valueIconHeight: {
			type: String,
			default: '20px'
		},
		isValueFirstIcon: Boolean,
		valueFirstIcon: String,
		valueFirstIconColor: {
			type: String,
			default: '#a3a3a3'
		},
		valueFirstIconWidth: {
			type: String,
			default: '20px'
		},
		valueFirstIconHeight: {
			type: String,
			default: '20px'
		},
		margin: {
			type: String,
			default: '0 10px'
		},
	},
	methods: {
		onClickIcon() {
			this.$emit('updateClickIcon');
		},
		onClickValue() {
			this.$emit('updateClickValue');
		},
	},
};
</script>
<style scoped lang="scss">
@import "itemInfoRow";
</style>
